// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Mongo_breadcrumb__PB2BV","statToolbar":"Mongo_statToolbar__m9kJk"};